import React from "react";
import { Pencil } from "lucide-react";
import { cn } from "../../../../../lib/utils";
import { SECTION_DISPLAY_NAMES } from "./schemas";

const STATUS_DOT = {
  blank: "bg-zinc-300",
  draft: "bg-amber-500",
  published: "bg-emerald-500",
  unpublished_changes: "bg-amber-500",
};

const STATUS_LABEL = {
  blank: "Not yet authored",
  draft: "Draft",
  published: "Published",
  unpublished_changes: "Unpublished changes",
};

// Wraps a rendered preview section with a click target + hover halo + edit
// affordance, so admins can click any section in the preview to open its
// editor.
const EditableHotspot = ({ sectionKey, status, isActive, onClick, children }) => {
  const label = SECTION_DISPLAY_NAMES[sectionKey] || sectionKey;
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
      className={cn(
        "group relative cursor-pointer rounded-xl outline-none transition",
        "ring-offset-2 ring-offset-[#f7f7f7]",
        isActive
          ? "ring-2 ring-blue-500"
          : "hover:ring-2 hover:ring-blue-300 focus-visible:ring-2 focus-visible:ring-blue-400"
      )}
      aria-label={`Edit ${label}`}
    >
      <div
        className={cn(
          "absolute -top-3 left-3 z-10 hidden items-center gap-1.5 rounded-full bg-white px-2.5 py-1 text-[11px] font-medium shadow-sm border",
          (isActive || true) && "group-hover:flex group-focus-visible:flex",
          isActive && "flex"
        )}
      >
        <span
          className={cn("h-1.5 w-1.5 rounded-full", STATUS_DOT[status] || STATUS_DOT.blank)}
          aria-hidden
        />
        <span className="text-zinc-700">{label}</span>
        <span className="text-zinc-400">·</span>
        <span className="text-zinc-500">{STATUS_LABEL[status] || STATUS_LABEL.blank}</span>
        <Pencil className="h-3 w-3 text-zinc-500 ml-1" />
      </div>
      {children}
    </div>
  );
};

export default EditableHotspot;
